export default "__VITE_ASSET__DM554FSR__"